<template>
  <div class="container">
    <ul>
      <li class="list-item "
          v-for="(item,index) in listData"
          data-type="0"
          :key="index">
        <div class="list-box"
             @touchstart.capture="touchStart"
             @touchend.capture="touchEnd"
             @click="skip">
          <!-- <div class="list-img">{{item.productCode}}</div>-->
          <div class="list-content">
            <p class="code">{{item.productCode}}</p>
            <p class="name">{{item.productName}}</p>
            <p class="price">{{item.productPrice}}</p>
            <p class="num">{{item.num}}</p>
          </div>
        </div>
        <div class="delete"
             @click="deleteItem($event,item.index)"
             :data-index="index">删除</div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: {
    // list: {
    //   type: Array,
    //   required: true
    // },
    list: {
      type: String,
      default: '[]'
    },
    ischange: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      listData: [],
      startX: 0,
      endX: 0
    }
  },
  methods: {
    // 跳转
    skip () {
      if (this.checkSlide()) {
        this.restSlide()
      }
    },
    // 滑动开始
    touchStart (e) {
      // 记录初始位置
      this.startX = e.touches[0].clientX
    },
    // 滑动结束
    touchEnd (e) {
      // 当前滑动的父级元素
      let parentElement = e.currentTarget.parentElement
      // 记录结束位置
      this.endX = e.changedTouches[0].clientX
      // 左滑
      if (parentElement.dataset.type == 0 && this.startX - this.endX > 30) {
        this.restSlide()
        parentElement.dataset.type = 1
      }
      // 右滑
      if (parentElement.dataset.type == 1 && this.startX - this.endX < -30) {
        this.restSlide()
        parentElement.dataset.type = 0
      }
      this.startX = 0
      this.endX = 0
    },
    // 判断当前是否有滑块处于滑动状态
    checkSlide () {
      let listItems = document.querySelectorAll('.list-item')
      for (let i = 0; i < listItems.length; i++) {
        if (listItems[i].dataset.type == 1) {
          return true
        }
      }
      return false
    },
    // 复位滑动状态
    restSlide () {
      let listItems = document.querySelectorAll('.list-item')
      // 复位
      for (let i = 0; i < listItems.length; i++) {
        listItems[i].dataset.type = 0
      }
    },
    // 删除
    deleteItem (e, index2) {
      // 当前索引
      let index = Number(e.currentTarget.dataset.index)
      index2 = Number(index2)
      // 复位
      this.restSlide()
      // 删除
      let currentRow = JSON.parse(JSON.stringify(this.listData))[index]
      // this.listData[index].num = 0
      this.listData.splice(index, 1)
      this.$emit('confirmDel', { currentRow, index, index2 })
    }
  },
  watch: {
    list (val) {
      this.listData = JSON.parse(val)//.concat(JSON.parse(val)).concat(JSON.parse(val)).concat(JSON.parse(val)).concat(JSON.parse(val))
    }
  }
}
</script>
<style scoped lang="less">
.container {
  ul,
  li {
    list-sytle: none;
    list-style-type: none;
    margin-block-start: 0em;
    margin-block-end: 0em;
    padding-inline-start: 0px;
  }
}
.page-title {
  text-align: center;
  font-size: 17px;
  padding: 10px 15px;
  position: relative;
}
.page-title:after {
  content: " ";
  position: absolute;
  left: 0;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #ccc;
  color: #ccc;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  z-index: 2;
}
.list-item {
  position: relative;
  // height: 1.6rem;
  height: 40px;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}
.list-item[data-type="0"] {
  transform: translate3d(0, 0, 0);
}
.list-item[data-type="1"] {
  transform: translate3d(-70px, 0, 0);
}
.list-item:after {
  content: " ";
  position: absolute;
  left: 0.2rem;
  bottom: 0;
  right: 0;
  height: 1px;
  border-bottom: 1px solid #ccc;
  color: #EBEEF5;
  -webkit-transform-origin: 0 100%;
  transform-origin: 0 100%;
  -webkit-transform: scaleY(0.5);
  transform: scaleY(0.5);
  z-index: 2;
}
.list-box {
  padding: 0.2rem 0.4rem 0.2rem 0.2rem;
  background: #fff;
  display: flex;
  align-items: center;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  justify-content: flex-end;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  font-size: 0;
}
.list-item .list-content {
  position: relative;
  flex: 1;
  display: flex;
  p {
    margin-block-start: 0em;
    margin-block-end: 0em;
    font-size: 14px;
    color: #606266;
    height: 38px;
    line-height: 38px;
    overflow: hidden;
    margin-right: 1%;
  }
  .code {
    width: 19%;
  }
  .name {
    width: 39%;
  }
  .price {
    width: 19%;
    text-align: right;
  }

  .num {
    width: 19%;
    display: block;
    font-size: 12px;
    position: absolute;
    right: 0;
    // top: 0.1rem;
    color: #666;
  }
}
.delete {
  width: 70px;
  background: #ff4949;
  font-size: 14px;
  color: #fff;
  text-align: center;
  position: absolute;
  top: 0;
  right: -70px;
  height: 38px;
  line-height: 38px;
  letter-spacing: 1px;
  border-top-left-radius: 3px;
  border-bottom-left-radius: 2px;
}
</style>


// WEBPACK FOOTER //
// src/components/slideDel/slideDel.vue